import { AMPLITUDE_EVENT_TYPES } from 'constants/amplitude';

export const FORM_FIELD_NAMES = {
  corporateClientName: 'corporateClientName',
  numberOfDrivers: 'numberOfDrivers',
  numberOfVehicles: 'numberOfVehicles',
  country: 'country',
  firstName: 'firstName',
  lastName: 'lastName',
  mobilePhoneNumber: 'mobilePhoneNumber',
  email: 'email',
  password: 'password',
  termsAndPrivacyAgreement: 'termsAndPrivacyAgreement',
};

export const VEHICLE_COUNT_COUNTRIES = ['CA', 'GB', 'US'];

export const FLEET_COUNT_RANGE_PATTERN = /^[1-9][0-9]{0,2}$/;

const FLEET_COUNT_SHARED_TRANSLATION_KEYS = {
  tooltip: 'corporateAccounts.selfRegistration.form.fleetCount.tooltip',
  required: 'corporateAccounts.corporateClient.fleetSize.validationError.fleetSizeRequired',
  range: 'corporateAccounts.selfRegistration.form.fleetCount.validationError.range',
};

export const FLEET_COUNT_FIELDS = {
  drivers: {
    name: FORM_FIELD_NAMES.numberOfDrivers,
    amplitudeEventType: AMPLITUDE_EVENT_TYPES.selfRegistrationDriverCountFieldClicked,
    translationKeys: {
      ...FLEET_COUNT_SHARED_TRANSLATION_KEYS,
      label: 'corporateAccounts.selfRegistration.form.numberOfDrivers',
      agreement: 'corporateAccounts.selfRegistration.form.agreement',
    },
  },
  vehicles: {
    name: FORM_FIELD_NAMES.numberOfVehicles,
    amplitudeEventType: AMPLITUDE_EVENT_TYPES.selfRegistrationVehicleCountFieldClicked,
    translationKeys: {
      ...FLEET_COUNT_SHARED_TRANSLATION_KEYS,
      label: 'corporateAccounts.selfRegistration.form.numberOfVehicles',
      agreement: 'corporateAccounts.selfRegistration.form.agreement.perVehicle',
    },
  },
};

export const RegistrationFlow = {
  SELF_V1: 'SELF_V1',
  SELF_V2_UK: 'SELF_V2_UK',
  SELF_V2_NON_UK: 'SELF_V2_NON_UK',
};
